import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const EaseOfUseExerciseEquipment = ({
  onEaseOfUseExerciseEquipmentSelected,
}) => {
  const [
    selectedEaseOfUseExerciseEquipment,
    setSelectedEaseOfUseExerciseEquipment,
  ] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.easeofuseexerciseequipment) {
        const easeOfUseExerciseEquipmentObject =
          firstResult.easeofuseexerciseequipment;
        if (easeOfUseExerciseEquipmentObject.trim() !== "") {
          setVariations(easeOfUseExerciseEquipmentObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleEaseOfUseExerciseEquipmentClick = (
    easeofuseexerciseequipment
  ) => {
    setSelectedEaseOfUseExerciseEquipment(easeofuseexerciseequipment);
    onEaseOfUseExerciseEquipmentSelected(easeofuseexerciseequipment);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Ease Of Use Exercise Equipment:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedEaseOfUseExerciseEquipment === variation ? "selected" : ""}`}
            onClick={() => handleEaseOfUseExerciseEquipmentClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default EaseOfUseExerciseEquipment;
